import {Injectable} from "@angular/core";
import {LoaderService} from "./loader.service";

@Injectable()
export class MapService {
  private map: IMapConfig;



  constructor(private loaderService: LoaderService) {
    this.loadCurrentMap();
  }


  private loadCurrentMap() {
    this.loaderService.load("meta/dump-current-map")
      .subscribe(r => {
        this.map = r.json()
      });
  }

  getSectorIdByObjectPosition(object: IObject) {
    if (!this.map) { return "wait"; }
    if (!object) { return "err obj"; }
    if (!object.cPosition) { return "no pos"; }

    const x = object.cPosition.x;
    const y = object.cPosition.y;

    const sectors = this.map.sectorsConfig.sectors;
    for (let i = 0; i < sectors.length; ++i) {
      const s = sectors[i];
      if (x >= s.x && x < s.x + s.w && y >= s.y && y < s.y + s.h) {
        return s.id;
      }
    }
    return "wtf?";
  }
}


interface IObject {
  id: 1,
  metaId: 176,
  cPosition: {
    x: number;
    y: number;
  }
}


interface IMapConfig {
  id: number;
  name: string;
  locationConfig: IMapLocationConfig;
  sectorsConfig: IMapSectorsConfig;
}


interface IMapLocationConfig {
  tileWidth: number;
  tileHeight: number;
}


interface IMapSectorsConfig {
  sectors:IMapSectorConfig[];
}


interface IMapSectorConfig {
  objects: any[];
  id: number;
  x: number;
  y:number;
  w:number;
  h:number;
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/map.service.ts